const ERROR_COMPONENT_DEFAULT_IMAGE = 'illustration_confirmation_error',
  ERROR_COMPONENT_DECLINED_IMAGE = 'illustration_emptystates_on-hold',
  ERROR_COMPONENT_STATES_IMAGE = 'illustration_emptystates_no-items',
  ERROR_CANT_CONTINUE_IMAGE = 'illustration_emptystates_connection-problem',
  UPLOAD_ID_CAMERA_FAILURE_IMAGE = 'illustration_L3_security_allow-permisions-default';

export {
  ERROR_COMPONENT_DECLINED_IMAGE,
  ERROR_COMPONENT_DEFAULT_IMAGE,
  ERROR_COMPONENT_STATES_IMAGE,
  ERROR_CANT_CONTINUE_IMAGE,
  UPLOAD_ID_CAMERA_FAILURE_IMAGE,
};
